module.exports = __webpack_public_path__ + "static/images/four.a5b3b1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/four.png
// module id = ykeU
// module chunks = 0